export default {
  /**
   * @function stripNaN
   * @description Converts a alphanumeric string into a numeric string
   * By removing all non-numbers in the text
   * @param val - the text which needs to be converted
   * @returns Number - the number from the formated string
   * @author NevetsKuro
   * @date 2024/04/03
   */
  stripNaN(val) {
    if (!isNaN(val.replace(',', ''))) {
      return parseFloat(val.replace(',', ''))
    } else if (isNaN(val)) {
      const stripAlpha = val.replace(/[^0-9.-]+/g, '')
      if (!stripAlpha) {
        return 0
      }
      return parseFloat(stripAlpha)
    } else {
      return 0
    }

    // } else if (val && typeof val === 'number') {
    //   return parseFloat(val)
    // } else {
    //   return 0
    // }
  },
  /**
   * @function convertToCurrency
   * @description Converts a numeric value to alphanumerc string
   * using .toLocaleString
   * @param val - the number from formatting the string
   * @returns String - the number in currency format
   * @author NevetsKuro
   * @date 2024/04/03
   */
  convertToCurrency(val) {
    let tmp = val
    if (typeof tmp === 'string') {
      tmp = this.stripNaN(val)
    }
    if (typeof tmp === 'number') {
      return Number(tmp).toLocaleString('en-US', {
        maximumFractionDigits: 20,
        minimumFractionDigits: 0
      })
    } else {
      return '0'
    }
  }
}
